export default "__VITE_ASSET__DD9QWHK3__"